enum MediaCampaignPosition {
  B1 = 'B1',
  B2 = 'B2'
}

export default MediaCampaignPosition;
